import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
import eight from "../assets/svg/projects/eight.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "Idea Incubator",
    projectDesc:
      "Idea Incubator is a solution to communicate new products or service ideas across the school programs, view ideas and communicate while observing user authentication, progressive disclosure of an idea’s concepts.",
    tags: ["C#", ".Net6 and Blazor", "MS SQL Server", "AzureDevOps"],
    code: "https://github.com/ilshin714/IdeaIncubator",
    demo: "https://www.youtube.com/playlist?list=PL9FhyXGSYnjVQ03FdzwywfvBlEf0nKsS_",
    image: three,
  },
  {
    id: 2,
    projectName: "e-commerse Organic Green",
    projectDesc:
      "This is a shopping mall for Korean Small and Midium sized farmers who do not have marketing resources.",
    tags: ["Java", "JavaScript", "Bootstrap", "Oracle"],
    code: "https://github.com/ilshin714/OrganicGreen_ShoppingMall_Java_Spring_Bootstrap_Oracle",
    demo: "https://www.youtube.com/watch?v=jodzRuqxWTA",
    image: five,
  },
  {
    id: 3,
    projectName: "Note Taking with Image",
    projectDesc: "This is a note taking web application using AWS Amplify",
    tags: ["React", "JavaScript", "AWS Amplify", "GraphQL", "VS Code"],
    code: "https://github.com/ilshin714/aws-amplify-react-graphql",
    demo: "https://main.d2zvig0km94anu.amplifyapp.com/",
    image: seven,
  },
  {
    id: 4,
    projectName: "Location Tracker",
    projectDesc:
      "Location Tracker is a Vue.js project that tracks user typed location with the help of Goole Maps Api.",
    tags: ["VUE js", "Semantic UI", "Google Maps Api"],
    code: "https://github.com/ilshin714/location-tracker",
    demo: "https://www.youtube.com/watch?v=-nLcC5TEtRc",
    image: eight,
  },
  {
    id: 5,
    projectName: "e-commerse Angela's Restaurant",
    projectDesc: `This e-commerce project is for a local business and consists of three websites in total. 
        The main brand site has been linked to two different restaurants' e-commerce sites, 
        allowing clients to recognize that they are under the same brand and creating a marketing effect.`,
    tags: ["WIX", "Velo", "Figma"],
    code: "https://hae7404.wixsite.com/angelabrand",
    demo: "https://hae7404.wixsite.com/angelabrand",
    image: six,
  },
  {
    id: 6,
    projectName: "Sales Management",
    projectDesc:
      "This project aims to build a sales management system that consolidates revenue of a company",
    tags: ["Java", "JavaSwing", "Oracle"],
    code: "",
    demo: "https://www.youtube.com/watch?v=1c8CWddmuPM",
    image: seven,
  },
  {
    id: 7,
    projectName: "Santa Delivery Game",
    projectDesc:
      "This project is a computer games using the latest object-oriented game development frameworks.",
    tags: ["C#", "MONOGAME", "XNA"],
    code: "https://github.com/ilshin714/SantaGameWIthMonoGame",
    demo: "https://www.youtube.com/watch?v=82HzrfaCALs",
    image: six,
  },
  // {
  //     id: 7,
  //     projectName: 'Stock Market App',
  //     projectDesc: 'A simple stock market API app',
  //     tags: ['React', 'Redux', 'Bootstrap'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: seven
  // },
  // {
  //     id: 8,
  //     projectName: 'Car Pooling System',
  //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
  //     tags: ['Flutter', 'React'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: eight
  // },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
